/* eslint-disable import/order */
import React from 'react';
import { ThemeSetter } from '@jira/platform__project-theme-setter/src/ThemeSetter.tsx';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { useRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { ThemeTokensSetter } from '@jira/platform__project-theme-components/src/ui/theme-tokens-setter/ThemeTokensSetter.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// exported for testing
export const useCurrentRouteSupportsProjectTheme: (
	// oxlint-disable-next-line typescript/no-invalid-void-type
	args_0: void,
) => 'full' | 'contoured' | undefined = createRouterSelector(
	(state) => state.route.supportsProjectTheme,
);

export const ProjectThemeSetter = (): React.JSX.Element => {
	const supportsProjectTheme = useCurrentRouteSupportsProjectTheme();
	const { queryReference } = useRelayResource(projectThemeResource);

	if (!queryReference || supportsProjectTheme == null) {
		/* The resource is available only for routes enabled for theming.
		We still need to set the default token color by using ThemeTokenSetter for all other routes.
		This can be removed once theming is enabled for all pages. */
		return <ThemeTokensSetter themeSetting={null} />;
	}

	return (
		<JSErrorBoundary id="projectThemeSetter" packageName="jiraPageContainerV2" teamName="wanjel">
			<Placeholder name="project-theme-setter-placeholder" fallback={null}>
				<ThemeSetter queryReference={queryReference} />
			</Placeholder>
		</JSErrorBoundary>
	);
};
